import { definedMap } from "collection-utils";
import { convertDateToTimeZoneAgnostic, nullToUndefined, sanitizeDateTime } from ".";

// Functions in this file used to be part of Support.ts, but they've all been
// banished out here due to this async chrono-node import.
//
// The await import completely breaks Webpack when trying to build
// the service worker.

let chrono: any;

const parsedDates = new Map<string, Date | undefined>();

export function parseUserDateTimeZoneAgnosticSync(str: string): Date | undefined {
    if (chrono === undefined) {
        return undefined;
    }

    if (parsedDates.has(str)) {
        return parsedDates.get(str);
    }

    if (parsedDates.size > 10000) {
        parsedDates.clear();
    }

    const sanitized = sanitizeDateTime(str, true);
    const parsed = definedMap(nullToUndefined(chrono.en.parseDate(sanitized)), convertDateToTimeZoneAgnostic);

    parsedDates.set(str, parsed);

    return parsed;
}

async function importChronoAndParseDate(str: string): Promise<Date | undefined> {
    // @ts-ignore
    chrono = await import("chrono-node");
    return parseUserDateTimeZoneAgnosticSync(str);
}

export function parseUserDateTimeZoneAgnostic(str: string): Promise<Date | undefined> | Date | undefined {
    if (chrono === undefined) {
        return importChronoAndParseDate(str);
    }
    return parseUserDateTimeZoneAgnosticSync(str);
}
